import React, { useEffect, useState } from "react";
import "../../styles/speciality.scss";
import { useHistory } from "react-router-dom";

const Speciality = (props) => {
  const history = useHistory();

  const [tagImg, setTagImg] = useState(null);

  const whiteIconBg = {
    background: "#ffffff3d",
  };

  const blueIconBg = {
    background: "#e1edff",
  };

  useEffect(() => {
    if (props.tag !== undefined) {
      const icon = `/${
        props.isBlue ? "blue_icons" : "white_icons"
      }/${(props.tag?.name).replace("and", "&").replace(/\s/g, "")}.svg`;

      const iconPath = process.env.PUBLIC_URL + icon;
      setTagImg(iconPath);
    }
  }, [props]);

  return (
    <>
      {props.tag !== undefined && (
        <div
          onClick={() => {
            if (props.clickable)
              history.push(`/search/1/posts/${props.tag.name}/${props.tag.id}`);
          }}
          className={`speciality-container ${
            props.clickable ? "speciality-tag" : ""
          }`}
        >
          {tagImg && (
            <div
              className="special-svg-wrapper"
              style={props.isBlue ? blueIconBg : whiteIconBg}
            >
              <div
                className="special-svg"
                style={{ backgroundImage: `url('${tagImg}')` }}
              />
            </div>
          )}
          <h6 className="speciality-name">{props.tag?.name}</h6>
          <style jsx="true">
            {`
              .speciality-tag {
                color: #0074c3;
                font-family: Lato;
                cursor: pointer;
              }
            `}
          </style>
        </div>
      )}
    </>
  );
};

export default Speciality;
